import React, { useState, useEffect } from "react";
import "./Navbar.css";
import PopupModal from './PopupModal';
import Cookies from 'js-cookie';
import axios from 'axios'; // Make sure axios is installed

function Navbar() {

  const hubspotutkCookie = Cookies.get('hubspotutk');

   const menu = [
    {
      id: "menu-item-61",
      label: "OFFERINGS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35952",
          label: "Automation Strategy",
          url: "https://zinnov.com/offerings/automation-strategy/",
        },
        {
          id: "menu-item-35955",
          label: "Business Growth & Transformation",
          url: "https://zinnov.com/offerings/business-growth-transformation/",
        },
        {
          id: "menu-item-35946",
          label: "GCC Setup & Transformation",
          url: "https://zinnov.com/offerings/gcc-setup-and-transformation/",
        },
        {
          id: "menu-item-35947",
          label: "GCC Platform",
          url: "https://zinnov.com/offerings/global-coe-accelerator-platform/",
        },
        {
          id: "menu-item-1418",
          label: "Innovation Strategy",
          url: "https://zinnov.com/offerings/innovation-strategy/",
        },
        {
          id: "menu-item-35949",
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/offerings/mergers-and-acquisitions/",
        },
        {
          id: "menu-item-76090",
          label: "Partner Strategy",
          url: "https://zinnov.com/offerings/partner-strategy/",
        },
        {
          id: "menu-item-35950",
          label: "Private Equity",
          url: "https://zinnov.com/offerings/private-equity/",
        },
        {
          id: "menu-item-35951",
          label: "Technology & Market Insights",
          url: "https://zinnov.com/offerings/technology-market-insights/",
        }
      ],
    },
    {
      id: "menu-item-60",
      label: "INDUSTRIES",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35933",
          label: "Enterprise Software",
          url: "https://zinnov.com/industry/enterprise-software/",
        },
        {
          id: "menu-item-35934",
          label: "ER&D and Digital Services",
          url: "https://zinnov.com/industry/erd-and-digital-services/",
        },
       {
          id: "menu-item-35939",
          label: "Healthcare",
          url: "https://zinnov.com/industry/healthcare/",
        },
        {
          id: "menu-item-35937",
          label: "Industrial",
          url: "https://zinnov.com/industry/industrial/",
        },
        {
          id: "menu-item-35932",
          label: "Internet & Technology Platforms",
          url: "https://zinnov.com/industry/internet-technology-platforms/",
        },
        {
          id: "menu-item-35941",
          label: "Private Equity",
          url: "https://zinnov.com/industry/private-equity/",
        },
      ],
    },
    {
      id: "menu-item-62",
      label: "INSIGHTS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35263",
          label: "Automation",
          url: "https://zinnov.com/automation/",
        },
        {
          id: "menu-item-35271",
          label: "Centers of Excellence",
          url: "https://zinnov.com/centers-of-excellence/",
        },
        {
          id: "menu-item-35274",
          label: "Digital Technologies",
          url: "https://zinnov.com/digital-technologies/",
        },
        {
          id: "menu-item-35270",
          label: "Diversity & Inclusion",
          url: "https://zinnov.com/i-and-d/",
        },
        {
          id: "menu-item-35268",
          label: "Engineering R&D",
          url: "https://zinnov.com/engineering-r-and-d/",
        },
        {
          id: "menu-item-35269",
          label: "Global Talent",
          url: "https://zinnov.com/global-talent/",
        },
        {
          id: "menu-item-35265",
          label: "Innovation",
          url: "https://zinnov.com/innovation/",
        },
        {
          id: "menu-item-35273",
          label: "Leadership & Transformation",
          url: "https://zinnov.com/leadership-and-transformation/",
        },
        {
          id: "menu-item-35264",
          label: "Macro Trends",
          url: "https://zinnov.com/macro-trends/",
        },
        {
          id: "menu-item-35267",
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/mergers-and-acquisitions/",
        },
        {
          id: "menu-item-35266",
          label: "Private Equity",
          url: "https://zinnov.com/private-equity/",
        },
        {
          id: "menu-item-35272",
          label: "Strategy & Ops",
          url: "https://zinnov.com/strategy-and-ops/",
        },
        {
          id: "menu-item-47402",
          label: "View All Insights",
          url: "https://zinnov.com/insights/",
        },
        {
          id: "menu-item-56633",
          label: "THE ZINNOV PODCAST",
          url: "https://zinnov.com/podcasts/",
        },
      ],
    },
    {
      id: "menu-item-63",
      label: "ABOUT US",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35957",
          label: "Our Purpose",
          url: "https://zinnov.com/about-us/our-purpose/",
        },
        {
          id: "menu-item-35958",
          label: "Our People and Culture",
          url: "https://zinnov.com/about-us/our-people/",
        },
        {
          id: "menu-item-35959",
          label: "Our Leadership",
          url: "https://zinnov.com/about-us/our-leadership/",
        },
        {
          id: "menu-item-35960",
          label: "Advisory Board",
          url: "https://zinnov.com/about-us/advisory-board/",
        },
        {
          id: "menu-item-35961",
          label: "Awards & Recognition",
          url: "https://zinnov.com/about-us/awards-and-recognition/",
        },
        {
          id: "menu-item-35962",
          label: "Partnerships & Alliances",
          url: "https://zinnov.com/about-us/alliances-and-partnerships/",
        },
        {
          id: "menu-item-63044",
          label: "Case Studies",
          url: "https://zinnov.com/case-studies/",
        },
      ],
    },
    {
      id: "menu-item-64",
      label: "CAREERS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35984",
          label: "Why Zinnov",
          url: "https://zinnov.com/careers/",
        },
        {
          id: "menu-item-35985",
          label: "Explore Opportunities",
          url: "https://zinnov.com/careers/explore-opportunities/",
        },
        {
          id: "menu-item-111",
          label: "Our People",
          url: "/careers/our-people",
        },
        {
          id: "menu-item-112",
          label: "Life @ Zinnov",
          url: "/careers/life-at-zinnov",
        },
      ],
    },
    {
      id: "menu-item-75486",
      label: "Our Customers",
      url: "https://zinnov.com/customers/"
    },
  ];

  const sidemenu = [
    {
      label: "OFFERINGS",
      children: [
        {
          label: "AUTOMATION STRATEGY",
          url: "https://zinnov.com/offerings/automation-strategy/",
        },
        {
          label: "BUSINESS GROWTH & TRANSFORMATION",
          url: "https://zinnov.com/offerings/business-growth-transformation/",
        },
        {
          label: "GCC SETUP & TRANSFORMATION",
          url: "https://zinnov.com/offerings/gcc-setup-and-transformation/",
        },
        {
          label: "GCC PLATFORM",
          url: "https://zinnov.com/offerings/global-coe-accelerator-platform/",
        },
        {
          label: "Innovation Strategy",
          url: "https://zinnov.com/offerings/innovation-strategy/",
        },
        {
          label: "MERGERS AND ACQUISITIONS",
          url: "https://zinnov.com/offerings/mergers-and-acquisitions/",
        },
        {
          label: "PARTNER STRATEGY",
          url: "https://zinnov.com/offerings/partner-strategy/",
        },
        {
          label: "PRIVATE EQUITY",
          url: "https://zinnov.com/offerings/private-equity/",
        },
        {
          label: "TECHNOLOGY & MARKET INSIGHTS",
          url: "https://zinnov.com/offerings/technology-market-insights/",
        },
      ],
    },
    {
      label: "INDUSTRIES",
      children: [
        {
          label: "Enterprise Software",
          url: "https://zinnov.com/industry/enterprise-software/",
        },
        {
          label: "ER&D and Digital Services",
          url: "https://zinnov.com/industry/erd-and-digital-services/",
        },
        {
          label: "Healthcare",
          url: "https://zinnov.com/industry/healthcare/",
        },
        {
          label: "Industrial",
          url: "https://zinnov.com/industry/industrial/",
        },
        {
          label: "Internet & Technology Platforms",
          url: "https://zinnov.com/industry/internet-technology-platforms/",
        },
        {
          label: "Private Equity",
          url: "https://zinnov.com/industry/private-equity/",
        },
      ],
    },
    {
      label: "INSIGHTS",
      children: [
        {
          label: "Automation",
          url: "https://zinnov.com/automation/",
        },
        {
          label: "Centers of Excellence",
          url: "https://zinnov.com/centers-of-excellence/",
        },
        {
          label: "Digital Technologies",
          url: "https://zinnov.com/digital-technologies/",
        },
        {
          label: "Diversity & Inclusion",
          url: "https://zinnov.com/i-and-d/",
        },
        {
          label: "Engineering R&D",
          url: "https://zinnov.com/engineering-r-and-d/",
        },
        {
          label: "Global Talent",
          url: "https://zinnov.com/global-talent/",
        },
        {
          label: "Innovation",
          url: "https://zinnov.com/innovation/",
        },
        {
          label: "Leadership & Transformation",
          url: "https://zinnov.com/leadership-and-transformation/",
        },
        {
          label: "Macro Trends",
          url: "https://zinnov.com/macro-trends/",
        },
        {
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/mergers-and-acquisitions/",
        },
        {
          label: "Private Equity",
          url: "https://zinnov.com/private-equity/",
        },
        {
          label: "Strategy & Ops",
          url: "https://zinnov.com/strategy-and-ops/",
        },
        {
          label: "VIEW ALL INSIGHTS",
          url: "https://zinnov.com/insights/",
        },
        {
          label: "THE ZINNOV PODCAST",
          url: "https://zinnov.com/podcasts/",
        },
      ],
    },
    {
      label: "ABOUT US",
      children: [
        {
          label: "OUR PURPOSE",
          url: "https://zinnov.com/about-us/our-purpose/",
        },
        {
          label: "OUR PEOPLE AND CULTURE",
          url: "https://zinnov.com/about-us/our-people/",
        },
        {
          label: "OUR LEADERSHIP",
          url: "https://zinnov.com/about-us/our-leadership/",
        },
        {
          label: "ADVISORY BOARD",
          url: "https://zinnov.com/about-us/advisory-board/",
        },
        {
          label: "AWARDS & RECOGNITIONS",
          url: "https://zinnov.com/about-us/awards-and-recognition/",
        },
        {
          label: "PARTNERSHIPS & ALLIANCES",
          url: "https://zinnov.com/about-us/alliances-and-partnerships/",
        },
        {
          label: "CASE STUDIES",
          url: "https://zinnov.com/case-studies/",
        },
      ],
    },
    {
      label: "CAREERS",
      children: [
        {
          label: "WHY ZINNOV",
          url: "https://zinnov.com/careers/",
        },
        {
          label: "EXPLORE OPPORTUNITIES",
          url: "https://zinnov.com/careers/explore-opportunities/",
        },
        {
          label: "OUR PEOPLE",
          url: "/careers/#hear-from-our-people",
        },
        {
          label: "LIFE @ ZINNOV",
          url: "/careers/#life-at-zinnov",
        },
      ],
    },
    {
      label: "OUR CUSTOMERS",
      url: "https://zinnov.com/customers/",
      children: [],
    },
    {
      label: "NEWSROOM / MEDIA",
      url: "https://zinnov.com/about-us/news-media/",
      children: [],
    },
    {
      label: "CONTACT US",
      url: "https://zinnov.com/contact-us/",
      children: [],
    },
  ];

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [searchActive, setSearchActive] = useState(false);
  const freeemailBlockedRegex = /\b(gmail|yahoo|outlook|hotmail|live|rediff|rediffmail|msn|aol|inbox|gmx|me|icloud|aim|orange|rocketmail)\.+\b/mi;
  const emailBlockedRegex = /\b(ey|bcg|bain|mckinsey|gartner|kpmg|deloitte|ansr|everestgrp|forrester|pwc|alumni|kearney|idc|marketsandmarkets|infinitiresearch|evalueserve|avasant|monitordeloitte|isg-one|bah|grailinsights|statxo|wiz-matic|accenture|fticonsulting|iney|avalonglobalresearch|ansrglobal|ernstandyoung|talent500|summit|mercer|nexdigm|apexgcc|aeriestechnology|thbs|parthenoney|researchfox|xpheno|moaradvisory|alvarezandmarsal|satechglobal|zs|procdna|pwandaffiliates|oliverwyman|bostonanalytics|collabera|consultavalon|bullhornconsultants|pylonmc|tworoadsconsulting|carlsonhall)\.+\b/gmi;
  const disposablemaildomainsRegex = /\b(0\-mail|027168|0815|0815|0815|0845|0box|0cd|0clickemail|0n0ff|0nelce|0rg|0v|0w|0wnd|0wnd|0x207|1\-8|1\-tm|10\-minute\-mail|1000rebates|100likers|105kg|10dk|10mail|10mail|10mail|10mail|10minmail|10minut\.com|10minut|10minutemail|10minutemail|10minutemail\.co|10minutemail\.co|10minutemail|10minutemail|10minutemail|10minutemail|10minutemail|10minutemail|10minutemail|10minutemail|10minutemail|10minutemailbox|10minutemails|10minutenemail|10minutenmail|10minutesmail|10minutesmail|10minutmail|10x9|11163|123\-m|12hosting|12houremail|12minutemail|12minutemail|12storage|140unichars|147|14n\.co|15qm|189|1blackmoon|1ce|1chuan|1clck2|1fsdfdsfsdf|1mail|1pad|1s|1secmail|1secmail|1secmail|1st\-forms|1to1mail|1usemail|1webmail|1xp|1zhuan|2012\-2016|20email|20email|20mail|20mail|20mail|20minutemail|20minutemail|20mm|2120001|21cn|247web|24hinbox|24hourmail|24hourmail|25u|2anom|2chmail|2ether|2fdgdfgdfgdf|2odem|2prong|2wc|300book|30mail|30minutemail|30wave|3202|36ru|3a88|3d\-painting|3l6|3mail|3trtretgfrfe|4\-n|4057|418|42o|42web|48hr|4gfdsgfdgfd|4k5|4mail|4mail|4nextmail|4nmv|4pu|4tb|4warding|4warding|4warding|50set|55hosting|5ghgfhfghfgh|5gramos|5july|5mail|5mail|5minutemail|5oz|5tb|5x25|5ymail|60minutemail|672643|675hosting|675hosting|675hosting|6hjgjhgkilkj|6ip|6mail|6mail|6mail|6paq|6somok|6url|75hosting|75hosting|75hosting|7days\-printing|7mail|7mail|7tags|80665|8127ep|8mail|8mail|8mail|99|99cows|99experts|9mail|9me|9mot|9ox|9q|a\-bc|a\-germandu|a45|a7996|aa5zy64|aaqwe|aaqwe|abacuswe|abakiss|abatido|abcmail|abevw|abilitywe|abovewe|absolutewe|abundantwe|abusemail|abuser|abyssmail|ac20mail|academiccommunity|academywe|acceleratewe|accentwe|acceptwe|acclaimwe|accordwe|accreditedwe|achievementwe|achievewe|acornwe|acrossgracealley|acrylicwe|activatewe|activitywe|acucre|acuitywe|acumenwe|adaptivewe|adaptwe|add3000\.pp|addictingtrailers|addrin|adeptwe|adfskj|adios|adiq|aditus|admiralwe|ado888|adobeccepdm|adoniswe|adpugh|adroh|adsd|adubiz|adult\-work|advantagewe|advantimo|adventurewe|adventwe|advisorwe|advocatewe|adwaterandstir|aegde|aegia|aegiscorp|aegiswe|aelo|aeonpsi|afarek|affiliate\-nebenjob|affiliatedwe|affilikingz|affinitywe|affluentwe|affordablewe|afia|afrobacon|afterhourswe|agedmail|agendawe|agger|agilewe|agorawe|agtx|aheadwe|ahem|ahk|ahmedkhlef|air2token|airmailbox|aiworldx|ajaxapp|akapost|akerd|akgq701|akmail|akugu|al\-qaeda|albionwe|alchemywe|aleh|alfaceti|aliaswe|alienware13|aligamel|alina\-schiesser|alisongamel|alisree|alivance|alivewe|all\-cats|allaccesswe|allamericanwe|allaroundwe|alldirectbuy|allegiancewe|allegrowe|allemojikeyboard|allgoodwe|alliancewe|allinonewe|allofthem|alloutwe|allowed|alloywe|allprowe|allseasonswe|allstarwe|allthegoodnamesaretaken|allurewe|almondwe|alph|alpha\-web|alphaomegawe|alpinewe|altairwe|altitudewe|altuswe|ama\-trade|ama\-trans|amadeuswe|amail|amail|amail1|amail4|amazon\-aws|amberwe|ambiancewe|ambitiouswe|amelabs|americanawe|americasbestwe|americaswe|amicuswe|amilegit|amiri|amiriindustries|amplewe|amplifiedwe|amplifywe|ampsylike|analogwe|analysiswe|analyticalwe|analyticswe|analyticwe|anappfor|anappthat|andreihusanu|andthen|animesos|anit|ano\-mail|anon\-mail|anonbox|anonmail|anonmails|anonymail|anonymbox|anonymized|anonymousness|anotherdomaincyka|ansibleemail|anthony\-junkmail|antireg|antireg|antispam|antispam24|antispammail|any|anyalias|anypng|aoeuhtns|apfelkorps|aphlog|apkmd|appc|appinventor|appixie|apps|appzily|arduino|ariaz|armyspy|aron|arroisijewellery|art\-en\-ligne|artman\-conception|arur01|arurgitu|arvato\-community|aschenbrandt|asciibinder|asdasd|asdasd|ashleyandrew|ask\-mail|asorent|ass\.pp|asso|assurmail|astonut|astroempires|asu|asu|at|at0mik|atnextmail|attnetwork|augmentationtechnology|ausgefallen|auti|autorobotica|autosouvenir39|autotwollow|autowb|averdov|avia\-tonic|avls|awatum|awdrt|awiki|awsoo|axiz|axon7zte|axsup|ayakamail|azazazatashkent|azcomputerworks|azmeil|azuretechtalk|b1of96u|b2bx|b2cmail|b7s|backilnge|badgerland|badoop|badpotato|balaket|bangban|banit|banit|bank\-opros1|bareed|barooko|barryogorman|bartdevos|basscode|bauwerke\-online|bazaaboom|bbbbyyzz|bbhost|bbitf|bbitj|bbitq|bcaoo|bcast|bcb|bccto|bcooq|bdmuzic|beaconmessenger|bearsarefuzzy|beddly|beefmilk|belamail|belgianairways|belljonestax|beluckygame|benipaula|benphim|bepureme|beribase|beribaza|berirabotay|berwie|best\-john\-boats|bestchoiceusedcar|bestlistbase|bestoption25|bestparadize|bestsoundeffects|besttempmail|betr|bflcafe|bgtmail|bgx|bheps|bidourlnks|big1|bigprofessor|bigstring|bigwhoop\.co|bij|bin\-ich|binich|binka|binkmail|binnary|bio\-muesli|bio\-muesli|bione|bitwhites|bitymails|biz|blackgoldagency|blackmarket|bladesmail|blip|blip|blnkt|block521|blogmyway|blogos|blogspam|blondemorkin|blondmail|bltiwd|bluedumpling|bluewerks|bnote|boatmail|bobgf|bobgf|bobmail|bobmurchison|bofthew|bonobo|boofx|bookthemmore|bootybay|borged|borged|borged|bot|botgetlink|boun|bouncr|box\-mail|box\-mail|boxem|boxem|boxfi|boxformail|boximail|boxlet|boxlet|boxmail|boxomail|boxtemp\.com|boyaga|bptfp|brand\-app|brandallday|brasx|breakthru|brefmail|brennendesreich|briggsmarcus|broadbandninja|bsnow|bspamfree|bspooky|bst\-72|btb\-notes|btc|btcmail|btcmod|btizet|buccalmassage|budaya\-tionghoa|budayationghoa|buffemail|bugfoo|bugmenever|bugmenot|bukhariansiddur|bulrushpress|bum|bumpymail|bunchofidiots|bund|bundes\-li|bunsenhoneydew|burnthespam|burstmail|businessbackend|businesssuccessislifesuccess|buspad|bussitussi|buy\-blog|buymoreplays|buyordie|buyusdomain|buyusedlibrarybooks|buzzcluby|byebyemail|byespm|byom|c1ph3r|c4|c51vsgq|caainpt|cachedot|californiafitnessdeals|cam4you|cameraity|camping\-grill|candymail|cane|cantozil|capitalistdilemma|car101|carbtc|cars2|carsencyclopedia|cartelera|caseedu|cashflow35|cashflow35|casualdx|catgroup|cavi|cbair|cbes|cbty|cbty|cc|ccmail|cctoolz|cdfaq|cdpa|ceed|cek|cellurl|centermail|centermail|cetpass|cfo2go|ch|chacuo|chaichuang|chalupaurybnicku|chammy|chansd|chapsmail|chasefreedomactivate|chatich|cheaphub|cheatmail|chenbot|chewydonut|chibakenma|chickenkiller|chielo|childsavetrust|chilkat|chinamkm|chithinh|chitthi|choco|chogmail|choicemail1|choigi|chong\-mail|chong\-mail|chong\-mail|chophim|chosenx|chumpstakingdumps|cigar\-auctions|citmo|civikli|civx|ckaazaza|ckiso|cl\-cl|cl0ne|claimab|clandest|classesmail|clearwatermail|click\-email|clickdeal|clipmail|clixser|clonemoi|cloud\-mail|cloudflare|cloudsign|clout|clowmail|clrmail|cmail|cmail|cmail|cmail|cmhvzylmfc|cnamed|cndps|cnew|cnmsg|cnsds|co|cobarekyo1|cocoro|cocovpn|codeandscotch|codivide|coffeetimer24|coieo|coin\-host|coinlink|coldemail|compareshippingrates|completegolfswing|comwest|conf|confmin|consumerriot|contbay|cooh\-2|coolandwacky|coolimpool|copyhome|coreclip|corhash|cosmorph|courrieltemporaire|coza|cpc|crankhole|crapmail|crastination|crazespaces|crazymailing|cream|crepeau12|cringemonster|cross\-law|cross\-law|crossmailjet|crossroadsmail|crunchcompass|crusthost|cs|csh|cszbl|ctmailing|ctos|cu|cubene|cubiclink|cuendita|cuirushi|cuoly|cupbest|curlhph|currentmail|curryworld|cust|cutefrogs|cutout|cutradition|cuvox|cyber\-innovation|cyber\-phone|cycinst|cyclelove|cylab|cypi|d1yun|d3p|daabox|dab|dacoolest|daemsteam|daibond|daily\-email|daintly|damai|dammexe|damnthespam|dandikmail|dann\.mywire|dao\.pp|daouse|darkharvestfilms|daryxfox|dasdasdascyka|dash\-pads|dataarca|datarca|datazo|datenschutz|datum2|davidkoh|davidlcreative|dawin|daymail|daymailonline|dayrep|dbunker|dcctb|dcemail|ddcrew|de\-a|dea\-21olympic|deadaddress|deadchildren|deadfake|deadfake|deadfake|deadfake|deadspam|deagot|dealja|deallabs|dealrek|decep|deekayen|deenur|defomail|degradedfun|deinbox|delayload|delayload|delikkt|delivrmail|demen|dengekibunko|dengekibunko|dengekibunko|der\-kombi|derkombi|derluxuswagen|desoz|despam|despammed|dev\-null|dev\-null|dev\-null|dev\-null|developermail|devnullmail|deyom|dharmatel|dhm|dhy|dialogus|diapaulpainting|dicopto|diemhenvn|digdig|digi\-value|digital\-message|digitalesbusiness|digitalmail|digitalmariachis|digitalsanctuary|dildosfromspace|dim\-coin|dingbone|diolang|directmail24|dis\.hopto|disaq|disbox|disbox|discard|discard|discard|discard|discard|discard|discardmail|discardmail|discos4|dishcatfish|disign\-concept|disign\-revelation|dispo|dispomail|disposable\-e|disposable\-email|disposable|disposable|disposable|disposable|disposableaddress|disposableemailaddresses|disposableinbox|disposablemails|dispose|disposeamail|disposemail|disposemymail|dispostable|divad|divermail|divismail|diwaq|dizigg|dldweb|dlemail|dmarc|dndent|dnses|doanart|dob|dodgeit|dodgemail|dodgit|dodgit|dodsi|doiea|dolphinnet|domforfb1|domforfb18|domforfb19|domforfb2|domforfb23|domforfb27|domforfb29|domforfb3|domforfb4|domforfb5|domforfb6|domforfb7|domforfb8|domforfb9|domozmail|donebyngle|donemail|dongqing365|dontreg|dontsendmespam|doojazz|doquier|dotman|dotmsg|dotslashrage|dotvu|dotzi|doublemail|douchelounge|dozvon\-spb|dp76|dpptd|dr69|drdrb|drdrb|dreamclarify|dred|drevo|driftz|dripzgaming|drivetagdev|drivz|drmail|droolingfanboy|dropcake|dropjar|droplar|dropmail|dropsin|drowblock|druzik\.pp|dsgvo|dsgvo|dshfjdafd|dsiay|dspwebservices|duam|duck2|dudmail|duk33|dukedish|dump\-email|dumpandjunk|dumpmail|dumpyemail|durandinterstellar|duskmail|dwse\.edu|dyceroprojects|dygovil|dz17|e\-mail|e\-mail|e\-marketstore|e\-tomarigi|e3z|e4ward|eanok|easy\-trash\-mail|easynetwork|easytrashmail|eatmea2z|eay|ebbob|ebeschlussbuch|ecallheandi|ecolo\-online|edgex|edinburgh\-airporthotels|edupolska\.edu|edv|ee1|ee2|eeedv|eelmail|efxs|egvoo|egzones|einmalmail|einrot|einrot|eintagsmail|elearningjournal|electro|elitevipatlantamodels|elki\-mkzn|email\-fake|email\-fake|email\-fake|email\-fake|email\-fake|email\-fake|email\-free|email\-jetable|email\-lab|email\-temp|email\.edu|email|email1|email10p|email60|email84|emailabox|emailage|emailage|emailage|emailage|emailage|emailaoa|emailate|emailawb|emailbbox|emailbin|emailcbox|emailcu|emaildbox|emaildienst|emaildrop|emailfake|emailfake|emailforyou|emailfoxi|emailfreedom|emailgenerator|emailgo|emailias|emailigo|emailinfive|emailisvalid|emaillime|emailmiser|emailna|emailnax|emailo|emailondeck|emailportal|emailproxsy|emailresort|emails|emailsecurer|emailsensei|emailsingularity|emailspam|emailspam|emailspam|emailspam|emailspam|emailsy|emailtech|emailtemporanea|emailtemporanea|emailtemporar|emailtemporario\.com|emailthe|emailtmp|emailto|emailure|emailvb|emailwarden|emailxfer|emailz|emailz|emailz|emailz|emeil|emeil|emeraldwebmail|emkei|emkei|emkei|emkei|emkei|eml\.pp|emlhub|emlpro|emltmp|empireanime|emstjzh|emz|enayu|enterto|envy17|eoffice|eoopy|ep77|epb|epbox|epbox|ephemail|ephemeral|eposta|eposta|epostal|epostal|eqiluxspam|ereplyzy|ericjohnson|eripo|ero\-tube|esadverse|esbano\-ru|esc|escapehatchapp|esemay|esgeneri|esiix|esprity|estate\-invest|esterace|eth2btc|ether123|ethereum1|ethersports|ethersportz|etotvibor|etranquil|etranquil|etranquil|euaqa|evanfox|eveav|evilcomputer|evnft|evopo|evusd|evvgo|evyush|exclussi|exdonuts|exelica|existiert|exitstageleft|explodemail|express\.net|extracurricularsociety|extremail|exweme|eyepaste|ez|ezehe|ezfill|ezstest|ezua|ezztt|f4k|facebook\-email|facebook\-email|facebook\-email|facebookmail|facebookmail|fackme|fadingemail|faecesmail|fag|failbone|faithkills|fake\-box|fake\-email\.pp|fake\-mail|fake\-mail|fake\-mail|fakedemail|fakeinbox|fakeinbox|fakeinbox|fakeinbox|fakeinbox|fakeinbox|fakeinformation|fakemail|fakemail|fakemailgenerator|fakemailz|fallinhay|fammix|fanclub|fangoh|fanicle|fansworldwide|fantasymail|farrse\.co|fasssd|fasssd|fast\-email|fast\-mail|fastacura|fastchevy|fastchrysler|fasternet|fastkawasaki|fastmazda|fastmitsubishi|fastnissan|fastsubaru|fastsuzuki|fasttoyota|fastyamaha|fatflap|fbma|fddns|fdfdsfds|femailtor|fer\-gabon|fermaxxi|fettometern|fexbox|fexbox|fexpost|fextemp|ficken|fictionsite|fightallspam|figjs|figshot|figurescoin|fiifke|filbert4u|filberts4u|filetodrive|film\-blog|filzmail|findemail|findu|finews|fir|firemailbox|fitnesrezink|fivemail|fivermail|fixmail|fizmail|flaimenet|fleckens|flemail|flexvio|fliegender|flowu|flu|fluidsoft|flurred|fly\-ts|flyinggeek|flymail|flyspam|flyzy|fncp|fncp|foobarbot|footard|foreastate|forecastertests|foreskin|foreskin|foreskin|foreskin|foreskin|forgetmail|formodapk|fornow|forspam|forward|fosil|foxja|foxtrotter|fr|fr|fr33mail|fragolina2|frapmail|frappina|free\-email|free\-email|free\-temp|freebabysittercam|freeblackbootytube|freecat|freedom4you|freedompop|freefattymovies|freehotmail|freeinbox|freelance\-france|freeletter|freemail|freemails|freemails|freemails|freemeil|freemeil|freemeil|freeml|freeplumpervideos|freerubli|freeschoolgirlvids|freesistercam|freesourcecodes|freeteenbums|freundin|friendlymail\.co|front14|frwdmail|ftp|ftpinc|fuckedupload|fuckingduh|fuckme69|fucknloveme|fuckxxme|fudgerub|fuirio|fukaru|fukurou|fullangle|fulvie|fun64|fundapk|funnycodesnippets|funnymail|furzauflunge|futuramind|fuvk|fuvk|fuwa|fuwa|fuwamofu|fuwari|fux0ringduh|fxnxs|fyii|g14l71lb|g1xmail|g2xmail|g3xmail|g4hdrop|gafy|gage|galaxy|gally|gamail|gamebcs|gamegregious|gamgling|garasikita|garbagecollector|garbagemail|gardenscape|garizo|garliclife|garrymccooey|gav0|gawab|gbcmail|gbmail|gcmail|gdmail|gedmail|geekforex|geew|gehensiemirnichtaufdensack|geldwaschmaschine|gelitik|genderfuck|geronra|geschent|get\-mail|get\-mail|get\-mail|get\-mail|get\.pp|get1mail|get2mail|getairmail|getairmail|getairmail|getairmail|getairmail|getairmail|geteit|getfun|getmailfree|getmails|getmule|getnada|getnada|getnowtoday|getonemail|getonemail|getover|getsimpleemail|gett|gexik|ggmal|ggvk|ggvk|gholar|ghosttexter|giacmosuaviet|giaiphapmuasam|giantmail|gifto12|gimme\-cooki|gimpmail|ginzi|ginzi\.co|ginzi|ginzi|ginzy\.co|ginzy|giratex|girlfriend|girlmail|girlsindetention|girlsundertheinfluence|gishpuppy|giveh2o|givememail|givmail|gixenmixen|glitch|globaltouron|glubex|glucosegrin|gmal|gmatch|gmial|gmx1mail|gmxmail|gmxmail|gnctr\-calgary|go2usa|go2vpn|goatmail|goemailgo|golemico|gomail|goonby|goplaygame|gorillaswithdirtyarmpits|goround|gosarlar|gosuslugi\-spravka|gothere|gotmail|gotmail|gotmail|gowikibooks|gowikicampus|gowikicars|gowikifilms|gowikigames|gowikimusic|gowikinetwork|gowikitravel|gowikitv|grandmamail|grandmasmail|grassdev|great\-host|greencafe24|greendike|greenhousemail|greensloth|greggamel|greggamel|gregorsky|gregorygamel|gregorygamel|grish|griuc|grn|groupbuff|grr|gruene\-no\-thanks|grugrug|gruz\-m|gs\-arc|gsredcross|gsrv\.co|gsxstring|gudanglowongan|guerillamail|guerillamail|guerillamail|guerillamail|guerillamail|guerillamail|guerillamailblock|guerrillamail|guerrillamail|guerrillamail|guerrillamail|guerrillamail|guerrillamail|guerrillamailblock|gufum|gustr|guysmail|gxemail|gynzi\.co|gynzi|gynzy|gynzy|gynzy|gynzy|gynzy|gynzy|gynzy|gynzy|gynzy|gynzy|gzb|h8s|haben\-wir|habenwir|habitue|hacccc|hackersquad|hackthatbit|hahawrong|haida\-edu|hairs24|haltospam|hamham|hangxomcuatoilatotoro|happy\-new\-year|happy2023year|happydomik|harakirimail|haribu|hartbot|hasanmail|hat\-geld|hatespam|hawrong|haydoo|hazelnut4u|hazelnuts4u|hazmatshipping|hccmail|headstrong|heathenhammer|heathenhero|hecat|heisei|hellodream|helloricky|helpinghandtaxcenter|helpjobs|heros3|herp|herpderp|hezll|hi2|hi5|hiddentragedy|hidebox|hidebusiness|hidemail|hidemail|hidemail|hidzz|highbros|hihi|hiltonvr|himail|hmail|hmamail|hmh|hoanggiaanh|hoanglong|hochsitze|hola|holio|holl|honeys|honor\-8|hopemail|hornyalwary|host1s|hostcalls|hostguru|hostingmail|hostlaba|hot\-mail|hot\-mail|hot\-mail|hot\-mail|hot\-mail|hotmai|hotmailproduct|hotmial|hotpop|hotprice|hotsoup|housat|hpc|hs|hsmw|ht|hthlm|huangniu8|huizk|hukkmu|hulapla|humaility|hungpackage|hunnur|hushmail|huskion|hvastudiesucces|hwsye|hxopi|hxopi|hypenated\-domain|i\-dork|i2pmail|i6\.cloudns|iaoss|ibnuh|ibolinva|icantbelieveineedtoexplainthisshit|icemail|ich\-essen\-fleisch|ichigo|icidroit|icx|icx|icznn|idx4|idxue|ieatspam|ieatspam|ieh\-mail|iencm|iffymedia|ige|igg|ignoremail|ihateyoualot|ihazspam|iheartspam|ikbenspamvrij|ikuromi|illistnoise|illubd|ilovespam|imail1|imails|imailt|imgof|imgv|immo\-gerance|imperialcnk|imstations|imul|in\-ulm|in2reach|inactivemachine|inbax|inbound|inbox|inbox2|inboxalias|inboxbear|inboxclean|inboxclean|inboxdesign|inboxed|inboxed|inboxkitten|inboxnow|inboxnow|inboxproxy|inboxstore|inclick|inclusiveprogress|incognitomail|incognitomail|incognitomail|incq|ind|indieclad|indigobook|indirect|indomaed|indomina|indoserver|indosukses|ineec|infocom\.zp|infos|inggo|inkiny|inkomail|inmynetwork|inoutmail|inoutmail|inoutmail|inoutmail|inpwa|insanumingeniumhomebrew|insorg\-mail|instaddr|instaddr|instaddr|instance\-email|instant\-mail|instantblingmail|instantemailaddress|instantletter|instantmail|instmail|instrete|intady|internet\-v\-stavropole|internetkeno|internetoftags|interstats|intersteller|intopwa|intopwa|intopwa|investore|iotf|iozak|ip4\.pp|ip6|ip6\.pp|ipoo|ippandansei|ipsur|ipxwan|irabops|iralborz|irc|irish2me|irishspringrealty|iroid|ironiebehindert|irssi|is|isdaq|ishop2k|isosq|ist\-hier|istii|isukrainestillacountry|it7|italy\-mail|itcompu|itfast|itsjiff|itunesgiftcodegenerator|iubridge|iuemail|iwi|ixaks|ixx|j\-p|jafps|jaga|jajxz|jakemsr|janproz|jaqis|javadmin|jdmadventures|jdz|je\-recycle|jellow|jellyrolls|jeoce|jet\-renovation|jetable|jetable|jetable|jetable\.pp|ji5|ji6|ji7|jiooq|jjj|jkotypc|jmail|jmail|jnxjn|jobbikszimpatizans|jobbrett|jobposts|jobs\-to\-be\-done|joelpet|joetestalot|jofuso|jopho|joseihorumon|josse|jourrapide|jp\-ml|jpco|jsrsolutions|jumonji|jungkamushukum|junk|junk1e|junkmail|junkmail|just\-email|justemail|juyouxi|jwork|jxpomup|kademen|kadokawa|kadokawa|kadokawa|kadokawa|kadokawa|kaengu|kagi|kakadua|kalapi|kamen\-market|kamsg|kaovo|kappala|kara\-turk|karatraman|kariplan|karta\-kykyruza|kartvelo|kasmail|kaspop|katztube|kazelink|kbox|kcrw|kd2|keepmymail|kein|keinhirn|keipino|kekita|kelenson|kellychibale\-researchgroup\-uct|kemptvillebaseball|kiani|killmail|killmail|kimsdisk|kinda|kindamail|kingsq|kino\-100|kiois|kismail|kisoq|kisstwink|kitnastar|kjkszpjcompany|kkmail|kkoup|kksm|klassmaster|klassmaster|klick\-tipp|klipschx12|kloap|klovenode|kludgemush|klzlk|kmail|kmail|kmhow|knickerbockerban|knmcadibav|knol\-power|kobrandly|kommunity|kon42|konican|konultant\-jurist|kook|kopagas|kopaka|korona\-nedvizhimosti|koshu|kosmetik\-obatkuat|kostenlosemailadresse|koszmail|kpay|kpooa|kpost|krd|kro|krsw|kruay|krypton|ksmtrck|kuhrap|kuku|kulmeo|kulturbetrieb|kumli|kurzepost|kutakbisajauhjauh|kvhrr|kvhrs|kvhrw|kwift|kwilco|kwtest|kyal|kyois|kyriog|kzccv|l\-c\-a|l33r|l6factors|laafd|labetteraverouge|labworld|lacedmail|lackmail|lackmail|lacto|lags|lain|lak\.pp|lakelivingstonrealestate|lakqs|lamasticots|lambsauce|landmail|laoeq|larisia|larland|last\-chance|laste|lastmail|lastmail|lawlita|laxex|laxex|laymro|lazyinbox|lazyinbox|ldaho|ldop|ldtp|le\-tim|lee|leeching|leetmail|legalrc|lellno|lenovog4|lerbhe|lerch|letthemeatspam|lez|lgxscreen|lhsdv|liamcyrus|lifebyfood|lifetimefriends|lifetotech|ligsb|lillemap|lilo|lilspam|lindenbaumjapan|link2mail|linkedintuts2016|linshiyou|linshiyouxiang|linuxmail|liocbrco|lista|litedrop|liveradio|lkgn|llogin|loadby|loan101|loaoa|loapq|locanto1|locantofuck|locantowsite|locomodev|login\-email|login\-email|login\-email|login\-email|logsmarter|logular|loh\.pp|loin|lolfreak|lolmail|lookugly|lordsofts|lortemail|losemymail|lovemeet|lovemeleaveme|lpfmgmtltd|lr7|lr78|lroid|lru|ls\-server|lsyx24|luckymail|lukecarriere|lukemail|lukop|luv2|lyfestylecreditsolutions|lyft|lyricspad|lzoaq|m21|m4ilweb|maboard|mabox|mac\-24|machen\-wir|macr2|macromaid|macromice|magamail|maggotymeat|magicbox|magim|magspam|maidlow|mail\-card|mail\-easy|mail\-filter|mail\-help|mail\-hosting|mail\-hub|mail\-now|mail\-owl|mail\-share|mail\-temporaire|mail\-temporaire|mail\-tester|mail|mail|mail0|mail1|mail114|mail1a|mail1web|mail21|mail22|mail2rss|mail333|mail4trash|mail666|mail7|mail707|mail72|mailadresi|mailapp|mailback|mailbai|mailbidon|mailbiscuit|mailbiz|mailblocks|mailbox\.in|mailbox|mailbox52|mailbox80|mailbox82|mailbox87|mailbox92|mailboxify|mailboxify|mailboxly|mailboxly|mailboxy|mailboxy|mailboxy|mailbucket|mailcat|mailcatch|mailchop|mailcker|maildax|mailde|mailde|maildrop|maildrop|maildrop|maildrop|maildrop|maildu|maildx|maileater|mailed|mailed|maileimer|maileme101|mailers\.edu|mailexpire|mailf5|mailfa|mailfall|mailfast|mailfirst|mailforspam|mailfree|mailfree|mailfree|mailfreeonline|mailfs|mailguard|mailgutter|mailhazard|mailhazard|mailhex|mailhub|mailhz|mailimate|mailin8r|mailinatar|mailinater|mailinator\.co|mailinator|mailinator|mailinator|mailinator|mailinator|mailinator|mailinator0|mailinator1|mailinator2|mailinator2|mailinator3|mailinator4|mailinator5|mailinator6|mailinator7|mailinator8|mailinator9|mailincubator|mailisia|mailismagic|mailita|mailjunk|mailjunk|mailjunk|mailjunk|mailjunk|mailmate|mailmaxy|mailme|mailme|mailme|mailme24|mailmenot|mailmetrash|mailmoat|mailmoth|mailms|mailna|mailna|mailna|mailna|mailnada|mailnada|mailnator|mailnesia|mailnull|mailnuo|mailonaut|mailorc|mailorg|mailosaur|mailox|mailpick|mailpluss|mailpooch|mailpoof|mailpress|mailproxsy|mailquack|mailrock|mailsac|mailscrap|mailseal|mailshell|mailshiv|mailsiphon|mailslapping|mailslite|mailsucker|mailt|mailt|mailtechx|mailtemp|mailtemporaire|mailtemporaire|mailto|mailtome|mailtothis|mailtraps|mailtrash|mailtrix|mailtv|mailtv|mailuniverse\.co|mailzi|mailzilla|mailzilla|mainerfolg|makemenaughty|makemetheking|malahov|malayalamdtp|mama3|mamulenok|mandraghen|manifestgenerator|mannawo|mansiondev|manybrain|mark\-compressoren|marketlink|markmurfin|mask03|maskmy|masonline|maswae|matamuasu|matchpol|matmayer|matra|max\-mail|maxturns|mbox|mbx|mc\-fly|mcache|mciek|mdhc|mdz|meantinc|mebelnu|mechanicalresumes|medkabinet\-uzi|meepsheep|megasend|mehr\-bitcoin|meidecn|meinspamschutz|meltedbrownies|meltmail|memsg|mentonit|mepost|merepost|merry|meruado|messagebeamer|messwiththebestdielikethe|metadownload|metaintern|metalunits|mezimages|mfsa|mfsa|mfunza|mhzayt|miaferrari|miauj|midcoastcustoms|midcoastcustoms|midcoastsolutions|midcoastsolutions|midiharmonica|midlertidig|midlertidig|midlertidig|mierdamail|migmail|migmail|migumail|mihep|miistermail|mijnhva|minimail|ministry\-of\-silly\-walks|minsmail|mintemail|mirai|misterpinball|miucce|mixzu|mji|mjj\.edu|mjukglass|mkpfilm|mkzaso|ml8|mliok|mm|mm5|mnode|moakt|moakt|moakt|moakt|mobileninja\.co|mobilevpn|moburl|mockmyid|moeri|mofu|mohmal|mohmal|mohmal|mohmal|moimoi|molms|momentics|monachat|monadi|monchu|moneypipe|monumentmail|moolee|moonapps|moonwake|moot|moreawesomethanyou|moreorcs|morriesworld|morsin|moruzza|motique|mountainregionallibrary|mowline|mox\.pp|moy\-elektrik|moza|mozej|mp\-j|mp3oxi|mr24|mrvpm|mrvpt|msgos|mspeciosa|msrc|msssg|mswork|msxd|mt2009|mt2014|mt2015|mtmdev|muadaingan|muathegame|muchomail|mucincanon|muehlacker|muell|muell|muell|muell|muellemail|muellmail|munoubengoshi|musiccode|mutant|mvrht|mvrht|mwarner|mxclip|mxfuel|my\-pomsies|my\-teddyy|my10minutemail|mybitti|mycleaninbox|mycorneroftheinter|myde|mydefipet|mydemo|myecho|myemailboxy|myfxspot|mygeoweb|myindohome|myinfoinc|myinterserver|mykickassideas|mymail\-in|mymail90|mymailoasis|mymaily|mynes|mynetstore|myopang|mypacks|mypartyclip|myphantomemail|mysamp|myspaceinc|myspaceinc|myspaceinc|myspacepimpedup|myspamless|mystvpn|mysugartime|mytemp|mytempemail|mytempmail|mytrashmail|mywarnernet|myweblaw|mywrld|mywrld|myzx|mzico|n1nja|na\-cat|naah|naah|nabuma|nada|nada|nagi|nakedtruth|namewok|nanonym|naslazhdai|nationalgardeningclub|navalcadets|nawmin|naymedia|nbmbb|nbzmr|negated|neghtlefi|neko2|nekochan|nekosan|neomailbox|neotlozhniy\-zaim|nepwk|nervmich|nervtmich|net1mail|netcom|netmails|netmails|netricity|netris|netviewer\-france|netzidiot|nevermail|newbpotato|newfilm24|newideasfornewpeople|newmail|next|nextmail|nextstopvalhalla|nezdiro|nezid|nezumi|nezzart|nfast|nguyenusedcars|nh3|nice\-4u|nick\-ao|nicknassar|nincsmail|nincsmail|niseko|niwl|nm123|nm7|nmail|nnh|nnot|nnoway|no\-spam|no\-trash|no\-ux|noblepioneer|nobugmail|nobulk|nobuma|noclickemail|nocp|nocp|nodezine|nogmailspam|noicd|nokdot|nokiamail|nolemail|nomail|nomail|nomail|nomail2me|nomorespamemails|nongnue|nonspam|nonspammer|nonze|noref|noreply|nori24|norseforce|norwegischlernen|nospam4|nospamfor|nospamthanks|nothingtoseehere|notif|notmailinator|notrnailinator|notsharingmy|now|nowhere|nowmymail|nowmymail|nproxi|ns01|nthrl|ntlhelp|nubescontrol|nullbox|nuox\.eu|nurfuerspam|nut|nutpa|nuts2trade|nvhrw|nwldx|nwytg|nwytg|ny7|nyasan|nypato|nyrmusic|o2stk|o7i|oakon|oalsp|obfusko|objectmail|obobbo|oborudovanieizturcii|obxpestcontrol|octovie|odaymail|odem|odnorazovoe|oepia|oerpub|offshore\-proxies|ofisher|ohaaa|ohi|oida|oing|okclprojects|okinawa|okrent|okzk|olimp\-case|oloh|oloh|olypmall|omail|omnievents|omtecha|one\-mail|one\-ml|one\-time|one2mail|onekisspresave|onemail|oneoffemail|oneoffmail|onetm\-ml|onetm|onewaymail|onlatedotcom|online|onlineidea|onlyapp|onqin|ontyne|oohioo|oolus|oonies\-shoprus|oopi|oosln|oovk|oovk|opayq|openavz|opendns|opentrash|opmmedia|opp24|optimaweb|opwebw|oranek|ordinaryamerican|oreidresume|orgmbx|oroki|oronny|orsbap|oshietechan|osxofulk|otherinbox|otmail|ourklips|ourpreviewdomain|outlawspam|outlook\.edu|outmail|ovomail|ovpn|owleyes|owlpic|ownsyou|owube|oxopoha|ozatvn|ozm|ozyl|p\-banlis|p33|p71ce1m|pa9e|pachilly|packiu|pagamenti|paharpurmim|pakadebu|pamaweb|pancakemail|papierkorb|paplease|para2019|parlimentpetitioner|pastebitch|pastryofistanbul|patonce|pavilionx2|payperex2|payspun|pe|pecinan|pecinan|pecinan|penisgoes|penoto|pepbot|peterdethier|petloca|petrzilka|pewpewpewpew|pflege\-schoene\-haut|pfui|phone\-elkey|photo\-impact|photomark|pi|piaa|pig\.pp|pii|piki|pimpedupmyspace|pinehill\-seattle|pingddns|pingir|pipemail|pisls|pitaniezdorovie|pitiful\.pp|pivo\-bar|pixdd|pixelgagnant|pixiil|pizu|pizu|pizzajunk|pjjkp|placebomail10|pleasenoham|plexfirm|plexolan|plhk|ploae|ploki|ploncy|plw|poehali\-otdihat|pofmagic|pojok|pokemail|pokiemobile|polarkingxx|politikerclub|polkaroad|polyfaust|pooae|poofy|pookmail|poopiebutt|popcornfarm7|popcornfly|popesodomy|popgx|poplk|porjoton|porsh|posdz|posta|postacin|postbx|postbx|postonline|poubelle\-du|poutineyourface|powered|powerencry|powlearn|pp7rvv|ppetw|pptrvv|pqoia|pratikmail|pratikmail|pratikmail|prazdnik\-37|prc|predatorrat|predatorrat|predatorrat|predatorrat|predatorrat|premium\-mail|pride\-worldwi|primabananen|prin|privacy\-mail|privacy|privatdemail|privmail\.edu|privy\-mail|privy\-mail|privymail|pro\-tag|pro5g|procrackers|profast|projectcl|promailt|proprietativalcea|propscore|protempmail|prout|proxymail|proxyparking|prtnx|prtshr|prtz|psh|psles|psnator|psoxs|ptct|ptsculure|puglieisi|puji|punkass|puppetmail|purcell|purelogistics|pursip|put2|puttanamaiala|putthisinyourspamdatabase|pwpwa|pwrby|qabq|qacmjeq|qasti|qbfree|qc|qejjyl|qibl|qiott|qipmail|qiq|qisdo|qisoa|qmrbe|qodiq|qoika|qopow|qq|qsl|qtum\-ico|quadrafit|questtechsystems|quick\-mail|quickemail|quickinbox|quickmail|quicksend|quillet|quipas|ququb|qvy|qwickmail|qzueos|r4nd0m|ra3|rabin|rabiot|rabitex|rackabzar|raetp9|rainbowly|raketenmann|raleigh\-construction|ramenmail|ramin200|rancidhome|randomail|randomail|rapt|raqid|rax|raxtest|razemail|razuz|rbb|rcasd|rcpt|rdklcrv|re\-gister|reality\-concept|reallymymail|realquickemail|realtyalerts|rebates|receiveee|recipeforfailure|recode|reconmail|recyclemail|redfeathercrow|reftoken|regapts|regbypass|regspaces|reimondo|rejectmail|rejo|reliable\-mail|remail|remail|remarkable|remote|rentaen|renydox|replyloop|reptilegenetics|resgedvgfed|revolvingdoorhoax|rf|rfc822|rhyta|richfinances|riddermark|rifkian|rinseart|rippb|risingsuntouch|riski|risu|rklips|rkomo|rm2rf|rma|rmqkr|rnailinator|ro|robertspcrepair|roborena|robot\-mail|roguemaster|rollindo|ronete|ronnierage|rootfest|rosebearmylove|rotaniliam|rover|rowe\-solutions|royal|royaldoodles|royalmarket|royandk|rppkn|rr|rsvhr|rteet|rtrtr|rtskiya|rudymail|rumgel|runi|rupayamail|ruru|rustydoor|rustyload|ruu|rvb|ryteto|ryyr|ryyr|s0ny|s33db0x|sabrestlouis|sackboii|saeoil|safaat|safermail|safersignup|safetymail|safetypost|saharanightstempe|sailmail|salmeow|samsclass|sandcars|sandelf|sandwhichvideo|sanfinder|sanim|sanstr|sast|satisfyme|satukosong|sausen|saynotospams|scatmail|scay|schachrol|schafmail|schmeissweg|schrott\-email|scrsot|sd3|sdvft|sdvgeft|sdvrecft|sebbcn|secmail|secretemail|secure\-mail|secure\-mail|secured\-link|securehost\.com|seekapps|seekjobs4u|sehier|sejaa|selfdestructingmail|selfdestructingmail|send22u|sendapp|sendfree|sendingspecialflyers|sendnow|sendspamhere|senseless\-entertainment|seosnaps|seqerc|server|servicee|services391|servicetr|sexforswingers|sexical|sexyalwasmi|sfolkar|sgatra|shadap|shalar|sharedmailbox|sharkfaces|sharklasers|shchiba|sheryli|shhmail|shhuut|shieldedmail|shieldemail|shiftmail|shipfromto|shiphazmat|shipping\-regulations|shippingterms|shitaway|shitmail|shitmail|shitmail|shmeriously|shopxda|shortmail|shotmail|showslow|shrib|shut|shut|siberpay|sidelka\-mytischi|sidement|siftportal|sify|sika3|sikux|silenceofthespam|siliwangi|silvercoin|sim\-simka|simaenaga|simpleitsecurity|sin|sinaite|sind\-hier|sind\-wir|sindhier|sindwir|sinema|sinfiltro|singlespride|sinnlos\-mail|sino|sinorto|siteposter|six25|sizzlemctwizzle|sjuaq|skeefmail|skrak|skrx|sky\-inbox|sky\-ts|skygazerhub|skyrt|slapsfromlastnight|slaskpost|slave\-auctions|slippery|slipry|slopsbox|slothmail|slushmail|sluteen|sly|smallker|smapfree24|smapfree24|smapfree24|smapfree24|smapfree24|smartemailbox|smartnator|smarttalent|smashmail|smellfear|smellrear|smellypotato|smeux|smtp99|smwg|smykwb|snakebutt|snakemail|snapmail|snapwet|sneakmail|snece|social\-mailer|socialfurry|sociallymediocre|sofia|sofimail|sofort\-mail|sofortmail|sofrge|softkey\-office|softpls|sogetthis|sohai|sohus|soioa|soisz|solar\-impact|solvemail|solventtrap|somelora|songsign|sonshi|soodmail|soodomail|soodonims|soombo|soon|soyboy|spacebazzar|spam\-be\-gone|spam|spam|spam|spam\.org|spam|spam4|spamail|spamarrest|spamavert|spambob|spambob|spambob|spambog|spambog|spambog|spambog|spambooger|spambox|spambox|spambox|spambox|spamcero|spamcon|spamcorptastic|spamcowboy|spamcowboy|spamcowboy|spamday|spamdecoy|spamex|spamfellas|spamfighter|spamfighter|spamfighter|spamfighter|spamfighter|spamfree|spamfree24|spamfree24|spamfree24|spamfree24|spamfree24|spamfree24|spamgoes|spamherelots|spamhereplease|spamhole|spamify|spaminator|spamkill|spaml|spaml|spamlot|spammer|spammotel|spammy|spamobox|spamoff|spamsalad|spamsandwich|spamslicer|spamsphere|spamspot|spamstack|spamthis\.co|spamthis|spamthisplease|spamtrail|spamtrap|spamtroll|spamwc|spamwc|spamwc|spamwc|speedgaus|sperma|spicysoda|spikio|spindl\-e|spinly|spoofmail|sportrid|spr|spritzzone|spruzme|spybox|spymail|spymail|squizzy|squizzy|sroff|sry|ssoia|stacys|stanfordujjain|starlight\-breaker|starmail|starpower|startfu|startkeys|statdvr|stathost|statiix|stayhome|steam\-area|steambot|stexsy|stinkefinger|stop\-my\-spam|stop\-my\-spam|stop\-my\-spam|stop\-my\-spam|stop\-my\-spam\.pp|stop\-my\-spam|stopspam|storiqax|storj99|storj99|streetwisemail|stromox|stuckmail|stuffmail|stumpfwerk|stylist\-volos|submic|suburbanthug|suckmyd|sudern|sueshaw|suexamplesb|suioe|super\-auswahl|superblohey|supergreatmail|supermailer|superplatyna|superrito|supersave|superstachel|superyp|suremail|sute|svetims|svip520|svk|svxr|sweetpotato|sweetxxx|swift\-mail|swift10minutemail|syinxun|sylvannet|symphonyresume|syosetu|syujob|szerz|tacomail|tafmail|tafoi|taglead|tagmymedia|tagyourself|talkinator|talmetry|tanlanav|tanukis|taobudao|tapchicuoihoi|taphear|tapi|tartinemoi|tarzanmail|tastrg|tatsu|taukah|taxibmt|tb\-on\-line|tcwlm|tcwlx|tdtda|tech69|techblast|techemail|techgroup|technoproxy|techusa|teerest|teewars|tefl|telecomix|teleg|telegmail|teleworm|teleworm|tellos|telvetto|teml|temp\-link|temp\-mail|temp\-mail|temp\-mail|temp\-mail\.pp|temp\-mail|temp\-mails|tempail|tempalias|tempe\-mail|tempemail|tempemail\.co|tempemail|tempemail|tempinbox\.co|tempinbox|tempmail|tempmail|tempmail|tempmail|tempmail|tempmail\.pp|tempmail|tempmail|tempmail2|tempmaildemo|tempmailer|tempmailer|tempmailer|tempmailo|tempmailyo|tempomail|tempomail|temporarily|temporarioemail\.com|temporary\-mail|temporaryemail|temporaryemail|temporaryforwarding|temporaryinbox|temporarymailaddress|tempr|tempsky|temptami|tempthe|tempymail|tensi|tenull|ternaklele|testore|testudine|tevstart|thanksnospam|thankyou2010|thatim|thc|the23app|theaviors|thebearshark|thecarinformation|thechildrensfocus|thecity|thecloudindex|thediamants|thedirhq|theeyeoftruth|thejoker5|thelightningmail|thelimestones|thembones\.com|themegreview|themostemail|thereddoors|theroyalweb|thescrappermovie|thespamfather|theteastory|thetechnext|thex|thichanthit|thietbivanphong|thirifara|thisisnotmyrealemail|thismail|thisurl|thnikka|thoas|thraml|thrma|throam|thrott|throwam|throwawayemailaddress|throwawaymail|throwawaymail\.pp|throya|thrubay|thunderbolt|thunkinator|thxmate|tiapz|tic|tidissajiiu|tilien|timgiarevn|timkassouf|tinoza|tinyurl24|tipsb|tittbit|tiv|tizi|tkitc|tlpn|tmail|tmail|tmail|tmail|tmail3|tmail9|tmailinator|tmails|tmmbt|tmpbox|tmpemails|tmpeml|tmpeml|tmpjr|tmpmail|tmpmail|tmpmailtor|tmpnator|tmpx\.sa|toddsbighug|tofeat|tohru|toiea|tokem|token|tokenmail|tonaeto|tonne|tonymanso|too|toolbox|toomail|toon|top\-shop\-tovar|top101|top1mail|top1post|topdatamaster|topinrock|topmail2|topmail2|topofertasdehoy|topranklist|toprumours|topvu|tormail|tospage|toss|tosunkaya|totallynotfake|totalvista|totesmail|totoan|tourcc|tp\-qa\-mail|tpwlb|tqoai|tqosi|trackden|tradermail|tranceversal|trap\-mail|trash\-amil|trash\-mail|trash\-mail|trash\-mail|trash\-mail|trash\-mail|trash\-mail|trash\-mail|trash\-mail|trash\-me|trash2009|trash2010|trash2011|trashcanmail|trashdevil|trashdevil|trashemail|trashemails|trashinbox|trashmail|trashmail|trashmail|trashmail|trashmail|trashmail|trashmail|trashmail|trashmail|trashmailer|trashmailgenerator|trashmails|trashymail|trashymail|trasz|trayna|trbvm|trbvn|trbvo|trend\-maker|trgfu|trgovinanaveliko|trialmail|trickmail|trillianpro|triots|trixtrux1|trollproject|tropicalbass|trungtamtoeic|truthfinderlogin|tryalert|tryninja|tryzoe|tsderp|ttirv|ttszuo|tualias|tuofs|tupmail|turoid|turual|turuma|tutuapp|tvchd|tverya|twinmail|twkly|twocowmail|twoweirdtricks|twzhhq|txcct|txen|txtadvertise|tyhe|tyldd|tympe|uacro|uber\-mail|ubinert|ubismail|ubm|ucche|ucupdong|uemail99|ufacturing|uggsrock|uguuchantele|uhe2|uhhu|uiu|ujijima1129|uk|ultra|ultrada|uma3|umail|undo|unicodeworld|unids|unimark|unit7lahaina|universall|unmail|uooos|uorak|upliftnow|uplipht|uploadnolimit|upozowac|urfunktion|urhen|uroid|us|us|usa|usako|usbc|used\-product|ushijima1129|ushijima1129|ushijima1129|ushijima1129|ushijima1129|utiket|uu|uu2|uuf|uuii|uwork4|uyhip|vaasfc4|vaati|vafyxh|valemail|valhalladev|vankin|vasteron|vctel|vda|vddaz|vdig|veanlo|vemomail|venompen|veo|ver0|ver0|ver0|ver0|ver0|vercelli|vercelli|vercelli|vercelli|verdejo|vermutlich|veryday|veryday|veryday|veryrealemail|ves|vesa|vevs|via\.tokyo|vibzi|vickaentb|victime|victoriantwins|vidchart|viditag|vidwobox|viewcastmedia|viewcastmedia|viewcastmedia|vigilantkeep|vikingsonly|vinernet|vintomaper|vipepe|vipmail|vipmail|vipxm|viralplays|virtualemail|visal007|visal168|visal168|visal168|visal168|visal168|visignal|vixletdev|vixtricks|vjoid|vjoid|vjuum|vkbb|vkbb|vkbt|vkbt|vkcbt|vkcbt|vkcode|vkfu|vkfu|vkpr|vkr1|vkrr|vkrr|vmailing|vmani|vmpanda|vncctv|vnedu|voidbay|volaj|voltaer|vomoto|vorga|votiputox|voxelcore|voxinh|vpn|vps30|vps911|vradportal|vremonte24\-store|vrmtr|vsimcard|vssms|vtxmail|vubby|vuiy|vuket|vusra|vvatxiy|vwhins|vztc|w\-asertun|w3internet\.co|wakingupesther|walala|walkmail|walkmail|wallm|wanko|watch\-harry\-potter|watchever|watchfull|watchironman3onlinefreefullmovie|waterisgone|watrf|wazabi|wbdev|wbml|web\-contact|web\-ideal|web\-inc|web\-mail\.pp|web2mailco|webcontact\-france|webemail|webhook|webm4il|webmail24|webscash|webtrip|webuser|wecp|wecp|wee|wef|weg\-werf\-email|wegwerf\-email\-addressen|wegwerf\-email\-adressen|wegwerf\-email|wegwerf\-email|wegwerf\-email|wegwerf\-emails|wegwerfadresse|wegwerfemail|wegwerfemail|wegwerfemail|wegwerfemail|wegwerfemail|wegwerfemailadresse|wegwerfmail|wegwerfmail|wegwerfmail|wegwerfmail|wegwerpmailadres|wegwrfmail|wegwrfmail|wegwrfmail|weizixu|wekawa|welikecookies|wellsfargocomcardholders|wemel|wenkuu|wentcity|wetrainbayarea|wetrainbayarea|wfgdfhj|wg0|wh4f|whaaaaaaaaaat|whatagarbage|whatiaas|whatifanalytics|whatpaas|whatsaas|whiffles|whopy|whyspam|wibblesmith|wickmail|widaryanto|widget|wiemei|wierie|wifimaple|wifioak|wikfee|wikidocuslava|wilemail|willhackforfood|willselfdestruct|wimsg|winemaven|wins\.com|wir\-sind|wishy|wlist|wlsom|wmail|wmail|wokcy|wolfmail|wolfsmail|wollan|womp\-wo|worldspace|wpdork|wpg|wralawfirm|writeme|wronghead|ws|wsym|wudet|wuespdj|wupics|wuuvo|wuzak|wuzup|wuzupmail|wwjmp|wwvk|wwvk|wwwnew|wxnw|wyoxafp|wywnxa|wzofit|x\-lab|x24|xagloo|xagloo|xbaby69|xcode|xcodes|xcompress|xcoxc|xcpy|xemaps|xemne|xents|xepa|xjoi|xkx|xl|xmail|xmailer|xmaily|xn\-\-9kq967o|xn\-\-d\-bga|xojxe|xost|xoxox|xperiae5|xrap|xrho|xstyled|xvx|xww|xxhamsterxx|xxi2|xxl|xxlocanto|xxolocanto|xxqx3802|xxvk|xxvk|xxxhi|xy9ce|xylar|xylar|xyzfree|xzsok|yabai\-oppai|yabes|yahmail|yahooproduct|yamail|yanet|yannmail|yapped|yaqp|yarnpedia|ycare|ycn|ye|yecp|yecp|yedi|yeezus|yep|yermail|yhg|ynmrealty|yodx|yogamaven|yoggm|yomail|yoo|yopmail|yopmail|yopmail|yopmail|yopmail\.pp|yordanmail|you\-spam|yougotgoated|youmail|youmailr|youneedmore|youpymail|your5|your5|yourdomain|youremail|yourewronghereswhy|yourlms|yourspamgoesto|yourtube|youxiang|yroid|yspend|ytnhy|ytpayy|yugasandrika|yui|yuoia|yuurok|ywzmb|yxdad|yxdad|yxzx|yyolf|z\-o\-e\-v\-a|z0d|z1p|z86|zain|zainmax|zaktouni|zarabotokdoma11|zasod|zaym\-zaym|zcovz|zcovz|zcrcd|zdenka|ze|zebins|zebins|zehnminuten|zehnminutenmail|zemzar|zepp|zetmail|zfymail|zhaoqian|zhaoyuanedu|zhcne|zhewei88|zhorachu|zik|zipcad|zipcatfish|zipo1|zippymail|zipsendtest|ziragold|zoaxe|zoemail|zoemail|zoemail|zoetropes|zombie\-hive|zomg|zsero|zudpck|zumpul|zv68|zvvzuv|zx81|zxcv|zxcvbnm|zymuying|zyns|zzi|zzrgg|zzz|movfull)\b/gmi;

  const [bgColor, setBgColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Change color after scrolling 100px
      if (scrollPosition > 200) {
        setBgColor("#292929");
      } else {
        setBgColor("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openClosePopUp = () => {
    setIsPopupOpen(prev => !prev);
  };  

  const handleSearchClick = () => {
    setSearchActive(true);
  };

  const handleCloseSearch = () => {
    setSearchActive(false);
  };

  // const toggleMenu = (index) => {
  //     // setOpenIndex(openIndex === index ? null : index);
  //     setOpenSideMenu(false);
  // };

  const toggleSideMenu = () => {
    setOpenSideMenu(!openSideMenu);
    setOpenIndex(null);
  };

  const toggleMenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleMouseEnter = () => {
    setHoveredMenu(true);
  };

  // Function to handle mouse leave event on sidebar menu
  const handleMouseLeave = () => {
    setHoveredMenu(false); 
    setOpenSideMenu(false); // Close sidebar menu when mouse leaves
  };

  const [formData, setFormData] = useState({
      firstname: '',
      lastname: '',
      company: '',
      jobtitle: '',
      email: '',
      query: '',
      message: '',
      subscribe_to_zinnov_newsletter: ''
  });
  const [errors, setErrors] = useState({});

  const validate = () => {

      let newErrors = {};
      if (!formData.firstname) newErrors.firstname = 'First Name is required';
      if (!formData.lastname) newErrors.lastname = 'Last Name is required';
      if (!formData.company) newErrors.company = 'Company is required';
      if (!formData.jobtitle) newErrors.jobtitle = 'Job Title is required';
      if (!formData.email) newErrors.email = 'Business Email is required';
      if (formData.email && !/\S+@\S+\.\S+/.test(formData.email) || freeemailBlockedRegex.test(formData.email) || emailBlockedRegex.test(formData.email) || disposablemaildomainsRegex.test(formData.email)) newErrors.email = 'Email address is invalid';
      if (!formData.query) newErrors.query = 'Query is required';
      if (!formData.message) newErrors.message = 'Message is required';
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
  };

  //console.log('Form data submitted:', formData);

  const handleChange = (e) => {
      // console.log('Testing On Change');
      const { id, value } = e.target;
      setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log('Testing On Submit');

    const searchParams = new URLSearchParams(window.location.search);
    const utm_source = (!(searchParams.get('utm_source'))?'na':searchParams.get('utm_source'));
    const utm_campaign = (!(searchParams.get('utm_campaign'))?'na':searchParams.get('utm_campaign'));
    const utm_medium = (!(searchParams.get('utm_medium'))?'na':searchParams.get('utm_medium'));
    const utm_term = (!(searchParams.get('utm_term'))?'na':searchParams.get('utm_term'));
    const utm_content = (!(searchParams.get('utm_content'))?'na':searchParams.get('utm_content'));
    const hubspotutkCookie = Cookies.get('hubspotutk');

    if (validate()) {

        // Form submission logic 
        // console.log('Form submitted:', formData);

        const firstname = formData.firstname;
        const lastname = formData.lastname;
        const email = formData.email;
        const query = formData.query;
        const message = formData.message;

        // console.log("First Name "+firstname);
        // console.log("Last Name "+lastname);
        // console.log("UTM Source "+utm_source);
        // console.log("UTM Medium "+utm_medium);
        // console.log("UTM Campaign "+utm_campaign);

        var data = {
          "submittedAt": Date.now(),
          "fields": [
            {
              "objectTypeId": "0-1",
              "name": "firstname",
              "value": firstname
            },
            ...(lastname ? [{ objectTypeId: '0-1', name: 'lastname', value: lastname }] : []),
            {
              "objectTypeId": "0-1",
              "name": "email",
              "value": email
            },
            {
              "objectTypeId": "0-1",
              "name": "query",
              "value": query
            },
            {
              "objectTypeId": "0-1",
              "name": "message",
              "value": message
            },
            {
              "objectTypeId": "0-1",
              "name": "page_url",
              "value": window.location.href
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_campaign",
              "value": utm_campaign
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_content",
              "value": utm_content
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_medium",
              "value": utm_medium
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_source",
              "value": utm_source
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_term",
              "value": utm_term
            }
          ],
          "context": {
                "hutk": hubspotutkCookie, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
                "pageUri": window.location.href,
                "pageName": document.getElementsByTagName("title")[0].innerHTML
           }
        }
      
        var final_data = JSON.stringify(data);

        axios.post('https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/contact_form.php', final_data)
            .then(response => {
                // console.log('Form data submitted:', response.data);
                window.location.href = 'https://zinnov.com/contact-us/thank-you/';
            })
            .catch(error => {
                // console.error('Error submitting form data:', error);
            });

        //formv3(firstName,lastName,formData.email,formData.message,utm_campaign,utm_medium,utm_source,utm_term,utm_content);
        //navigate('/thank-you',{state: {firstName: firstName, lastName: lastName, email: formData.email, utm_campaign: utm_campaign, utm_medium: utm_medium, utm_source: utm_source, utm_term: utm_term, utm_content: utm_content,whichform: 'contact form'}});

        // Clear form data
        setFormData({
          firstname: '',
          lastname: '',
          company: '',
          jobtitle: '',
          email: '',
          query: '',
          message: '',
          subscribe_to_zinnov_newsletter: ''
        });
        // Clear errors
        setErrors({});
        setIsPopupOpen(false); // Close the popup after submission

    }
    
  };

  return (
    <div id="nav-bar">
      <div id="container-menus" style={{ backgroundColor: bgColor }}>
        <nav role="navigation" id="secondary-menu" class="secondary-menu">
          <div class="header-menu-class">
            <ul
              id="menu-secondary-menu"
              class="menu"
              style={{ transform: "none" }}
            >
              <li
                id="menu-item-37499"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-37499"
              >
                <a href="https://zinnov.com/about-us/news-media/">
                  NEWSROOM / MEDIA
                </a>
              </li>
              <li
                id="menu-item-63122"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-63122"
              >
                <a href="https://zinnov.com/contact-us/">CONTACT US</a>
              </li>
            </ul>
          </div>
        </nav>
        <nav role="navigation" id="main-menu" className="main-menu">
          <div className="header-menu-class">
            <ul id="menu-header" className="menu">
            {menu.map((item, index) => (
              <li
                key={item.id}
                className={`menu-item menu-item-type-custom menu-item-object-custom ${item.subMenu ? 'menu-item-has-children' : ''}`}
                onMouseEnter={() => setHoveredMenu(index)}
                onMouseLeave={() => setHoveredMenu(null)}
              >
                {item.subMenu && item.subMenu.length > 0 ? (
                  <>
                    <a role="button">{item.label}</a>
                    {hoveredMenu === index && (
                      <ul className="sub-menu">
                        {item.subMenu.map((subItem) => (
                          <li
                            key={subItem.id}
                            className="menu-item menu-item-type-post_type menu-item-object-page"
                          >
                            <a href={subItem.url}>{subItem.label}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <a href={item.url}>{item.label}</a>
                )}
              </li>
            ))}
          </ul>
          </div>

          <div id="sandwich-menu">
            {!openSideMenu ? (
              <div id="menuToggle" onClick={toggleSideMenu}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <div id="menuToggle-close" onClick={toggleSideMenu}>
                <span></span>
              </div>
            )}

            {openSideMenu && (
              <div
                className="header-menu-colpased-class"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <ul id="menu-sandwich-menu" className="menu">
                {sidemenu.map((item) => (
                  <li
                    key={item.id}
                    className={`menu-item menu-item-type-custom menu-item-object-custom ${
                      item.children && item.children.length > 0 ? "menu-item-has-children" : ""
                    }`}
                  >
                    {item.children && item.children.length > 0 ? (
                      <>
                        <a role="button">{item.label}</a>
                        <ul className="sub-menu">
                          {item.children.map((listitems) => (
                            <li
                              key={listitems.id}
                              className="menu-item menu-item-type-post_type menu-item-object-page"
                            >
                              <a href={listitems.url}>{listitems.label}</a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <a href={item.url}>{item.label}</a>
                    )}
                  </li>
                ))}
              </ul>
                <div className="sandwich-menu-social-icons">
                  <a
                    href="https://www.linkedin.com/company/zinnov"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/linkedin.png"
                      alt="LinkedIn"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/ZinnovManagementConsulting"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/facebook.png"
                      alt="Facebook"
                    />
                  </a>
                  <a href="https://twitter.com/zinnov" target="_self">
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/twitter.png"
                      alt="Twitter"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/c/ZinnovManagementConsulting"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/youtube.png"
                      alt="Youtube"
                    />
                  </a>
                </div>
              </div>
            )}
          </div>

          <div class="zinnovlogo">
            <div class="zinnovlogo-wrapper">
              <a href="https://zinnov.com">
                <img
                  src="https://zinnov.com/wp-content/themes/zinnov/images/zinnov-home.svg"
                  alt="Zinnov"
                />
              </a>
            </div>
          </div>

          <div
            role="search"
            id="search-menu"
            className={searchActive ? "open-search-menu" : ""}
          >
            <div   onClick={openClosePopUp}
              className={`header-sticky-contact-us ${
                searchActive ? "hide-contact-us" : ""
              }`}
              
            >
              <img
                class="header-sticky-contact-us-icon"
                src="https://zinnov.com/wp-content/themes/zinnov/assets/contact-us.png"
                alt="Contact us"
              />
            </div>

            <form
              id="searchform"
              action="https://zinnov.com/search-results"
              method="POST"
            >
              {!searchActive ? (
                <img
                  id="search-menu-icon"
                  height="28"
                  width="28"
                  src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/search.svg"
                  alt="Search icon"
                  onClick={handleSearchClick}
                />
              ) : (
                <>
                  <img
                    id="search-menu-icon"
                    height="28"
                    width="28"
                    src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/search.svg"
                    alt="Search icon"
                    onClick={handleSearchClick}
                  />
                  <input
                    id="search-menu-input"
                    name="q"
                    autoFocus
                    type="text"
                    required
                    style={{ display: "inline-block" }}
                  />
                  <img
                    id="simple-x-icon"
                    height="12"
                    width="12"
                    src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/close.svg"
                    alt="Close icon"
                    style={{ display: "block" }}
                    onClick={handleCloseSearch}
                  />
                </>
              )}
            </form>
          </div>

        </nav>
      </div>
      <PopupModal isOpen={isPopupOpen} onClose={openClosePopUp} onSubmit={handleSubmit} onChange={handleChange} formData={formData} />

    </div>
  );
}

export default Navbar;
